<template>
  <portal to="page-title">
    <div class="header">
      <UiLink v-if="!hideArrow" class="arrow" v-bind="backLink">
        <UiBaseIcon width="20px" height="20px" color="black" icon-name="arrowLeft" />
      </UiLink>

      <h1 v-if="title" class="title">{{ title }}</h1>

      <slot v-if="$slots.right" name="right" />
    </div>

    <!-- <slot v-if="$slots.bottom" name="bottom" /> -->
  </portal>
</template>

<script>
import UiBaseIcon from '@/components/icons/UiBaseIcon.vue'
import UiLink from '@/components/UiLink.vue'

export default {
  components: { UiBaseIcon, UiLink },
  props: {
    title: {
      type: String,
      default: '',
    },
    hideArrow: {
      type: Boolean,
      defaul: false,
    },
    backLink: {
      type: Object,
      default: () => ({}),
    },
  },
}
</script>

<style lang="scss" scoped>
.header {
  margin: 0 0 0 rem(20px);

  @include createFlex(flexbox, nowrap, row, flex-start, center, center);

  @include media_tablet {
    margin: 0;
  }

  .arrow {
    margin: 0 rem(14px) 0 0;
  }

  .title {
    display: none;
    font-size: rem(20px);
    color: $color-gray-600;

    @include media_tablet {
      display: inline-block;
    }
  }
}
</style>
